import clsx from 'clsx';
import { ComponentPropsWithoutRef, FC, useRef } from 'react';
import { useIntersection } from 'react-use';
import { formatRelativeForDateDivider } from '../../Message/util/message.util';

interface DateDividerProps extends Pick<ComponentPropsWithoutRef<'div'>, 'className'> {
  date: Date;
  intersectionRoot?: Element | null;
}

export const DateDivider: FC<DateDividerProps> = ({ date, className, intersectionRoot }) => {
  const ref = useRef<HTMLDivElement>(null);
  const intersection = useIntersection(ref, {
    threshold: 1,
    root: intersectionRoot,
  });

  const isSticky = intersection && intersection.intersectionRatio < 1 && intersection.boundingClientRect.top <= 74;

  return (
    <div
      ref={ref}
      style={{ width: isSticky ? 'calc(100% + 72px)' : '100%' }}
      className={clsx(
        'sticky top-[-25px] z-10 flex h-8 w-full flex-col justify-center border-b border-b-darkMode-gray-medium/40',
        isSticky && '-ml-7 border-b-2 !border-b-black bg-[#1E2023] pl-7',
        className
      )}
    >
      <p className="date-divider-text text-sm font-medium capitalize leading-[16px] text-darkMode-gray-light">
        {formatRelativeForDateDivider(date)}
      </p>
    </div>
  );
};
